{
 "name": "0_plant_mushroom1",
 "bin": "0_plant_mushroom1.bin",
 "nodes": [
  {"name": "", "parent": -1, "t": [0,0,0], "q": [0,0,0,1], "s": [1,1,1]},
  {"name": "Fbx_Root", "parent": 0, "t": [0,0,0], "q": [-0.7071068,0,0,0.7071068], "s": [0.0254,0.0254,0.0254]},
  {"name": "Producer Perspective", "parent": 0, "t": [0,0.713,2.875], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Top", "parent": 0, "t": [0,40,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Bottom", "parent": 0, "t": [0,-40,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Front", "parent": 0, "t": [0,0,40], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Back", "parent": 0, "t": [0,0,-40], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Right", "parent": 0, "t": [40,0,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Producer Left", "parent": 0, "t": [-40,0,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "Camera Switcher", "parent": 0, "t": [0,0,0], "q": [0,0,0,1], "s": [0.01,0.01,0.01]},
  {"name": "0_plant_mushroom1", "parent": 1, "t": [-1.259826,-33.13779,0], "q": [-0.7069844,-0.002802851,-0.002568292,0.707219], "s": [1.2,1.2,1.2]},
  {"name": "", "parent": 10, "t": [1.05895,0.01716461,27.61448], "q": [0,0,0,1], "s": [1,1,1]},
  {"name": "Sphere01", "parent": 10, "t": [1.05895,0.01716418,40.61717], "q": [0.04357595,-0.04324689,-0.001917195,0.9981118], "s": [1,1,0.6729034]},
  {"name": "Capsule01", "parent": 10, "t": [1.05895,0.0171627,-0.4347935], "q": [0,0,0,1], "s": [1,1,1]}
 ],
 "parts": [
  {"node": 12, "vertexCount": 144, "posOffset": 0, "nrmOffset": 1728, "uvOffset": 3456, "material": "0_plant_mushroom1", "color": [1,0,0,1], "texture": "0_plant_mushroom1a.png"},
  {"node": 13, "vertexCount": 75, "posOffset": 4608, "nrmOffset": 5508, "uvOffset": 6408, "material": "0_plant_mushroom1_stiel", "color": [1,1,1,1]}
 ],
 "anims": [
  {"name": "die", "duration": 0.8, "fps": 30, "frames": 25, "offset": 7008},
  {"name": "grow", "duration": 3.3, "fps": 30, "frames": 100, "offset": 21008},
  {"name": "idle", "duration": 0.36667, "fps": 30, "frames": 12, "offset": 77008},
  {"name": "pick", "duration": 0.96667, "fps": 30, "frames": 30, "offset": 83728}
 ]
}
